import { EResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setJsonQuery = actionGenerator<EResultsActionType.SetJsonQuery, TJsonQuery>(
  EResultsActionType.SetJsonQuery,
);
